import React from 'react';
import { motion } from 'framer-motion';
import { Pencil, Star, Sparkles, BookOpen, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-brand-blue/30 to-brand-mint/20 pt-24 pb-20 lg:pt-32 lg:pb-28" data-id="element-46">
      {/* Decorative background elements */}
      <div className="absolute top-10 left-10 text-brand-yellow opacity-60 animate-pulse" data-id="element-47">
        <Star size={48} fill="currentColor" data-id="element-48" />
      </div>
      <div className="absolute top-40 right-20 text-brand-lilac opacity-60 animate-bounce" style={{
      animationDuration: '3s'
    }} data-id="element-49">
        <Sparkles size={40} data-id="element-50" />
      </div>
      <div className="absolute bottom-20 left-1/4 text-brand-mint opacity-60" data-id="element-51">
        <Pencil size={32} className="rotate-45" data-id="element-52" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-53">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-54">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="relative text-center lg:text-left" data-id="element-55">
            {/* Watermark logo behind the title */}
            <img src="https://cdn.magicpatterns.com/uploads/aAjBCQ2Pp84DDoez1vKjke/WhatsApp_Image_2026-06-11_at_19.05.02-Photoroom.png" alt="" aria-hidden="true" className="pointer-events-none select-none absolute -top-16 left-1/2 lg:left-0 -translate-x-1/2 lg:translate-x-0 w-[420px] max-w-none opacity-[0.07] z-0" data-id="element-56" />

            <div className="relative z-10 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-brand-blue text-brand-primary font-bold text-sm mb-6 shadow-sm" data-id="element-57">
              <Star size={16} fill="currentColor" data-id="element-58" />
              <span data-id="element-59">Para niños de 3 a 10 años</span>
            </div>

            <h1 className="relative z-10 text-5xl lg:text-6xl font-extrabold text-brand-dark mb-6 leading-tight" data-id="element-60">
              <span className="inline-block mr-3" data-id="element-61">✏️</span>
              Método{' '}
              <span className="text-brand-primary relative" data-id="element-62">
                Escribo Jugando
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-brand-yellow" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-63">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" data-id="element-64" />
                </svg>
              </span>
            </h1>

            <p className="lg:text-2xl font-display font-semibold text-brand-dark mb-4 text-[18px]" data-id="element-65">
              Ayuda a tu hijo a mejorar su escritura, concentración y motricidad
              fina mientras aprende jugando.
            </p>

            <p className="text-lg text-brand-text mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-66">
              Un sistema completo con actividades, juegos y ejercicios diseñados
              para niños. Ideal para mamás y docentes que buscan enseñar de
              forma simple, divertida y efectiva.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10" data-id="element-67">
              <div className="flex flex-col items-center lg:items-start" data-id="element-68">
                <a href="https://checkout.complementodigital.shop/cart/40783303901313:1" target="_blank" rel="noopener noreferrer" className="btn-primary w-full sm:w-auto group relative overflow-hidden" data-id="element-69">
                  <span className="relative z-10 flex items-center gap-2" data-id="element-70">
                    🔥 SOLO POR HOY $18.990
                  </span>
                  <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-71" />
                </a>
                <span className="text-sm text-slate-500 mt-2 line-through font-semibold" data-id="element-72">
                  Antes $49.990
                </span>
              </div>
              <a href="#incluye" className="btn-secondary w-full sm:w-auto" data-id="element-73">
                Ver Todo Lo Que Incluye
              </a>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-sm font-bold text-brand-dark" data-id="element-74">
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg shadow-sm" data-id="element-75">
                <CheckCircle2 size={18} className="text-green-500" data-id="element-76" /> 5 Módulos
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg shadow-sm" data-id="element-77">
                <CheckCircle2 size={18} className="text-green-500" data-id="element-78" /> 6 Bonus
              </div>
              <div className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-lg shadow-sm" data-id="element-79">
                <CheckCircle2 size={18} className="text-green-500" data-id="element-80" /> 3 Plus
              </div>
              <div className="flex items-center gap-1.5 bg-brand-yellow/50 px-3 py-1.5 rounded-lg shadow-sm" data-id="element-81">
                <BookOpen size={18} className="text-amber-600" data-id="element-82" /> Plantillas
                Imprimibles
              </div>
            </div>
          </motion.div>

          {/* Image/Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-83">
            <div className="absolute inset-0 bg-brand-primary/10 rounded-full blur-3xl transform -translate-y-10" data-id="element-84"></div>
            <div className="relative bg-white p-4 rounded-3xl shadow-soft border-4 border-brand-blue/30 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-85">
              <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Niño aprendiendo a escribir feliz" className="rounded-2xl w-full h-auto object-cover aspect-[4/3]" data-id="element-86" />
              {/* Floating elements over the image */}
              <div className="absolute -bottom-6 -left-6 bg-brand-yellow p-4 rounded-2xl shadow-lg border-2 border-white transform -rotate-6" data-id="element-87">
                <p className="font-display font-bold text-brand-dark text-lg leading-tight" data-id="element-88">
                  ¡Aprender
                  <br data-id="element-89" />
                  es divertido!
                </p>
              </div>
              <div className="absolute -top-6 -right-6 bg-brand-mint p-3 rounded-full shadow-lg border-2 border-white" data-id="element-90">
                <Star size={32} className="text-emerald-600" fill="currentColor" data-id="element-91" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}